import store from '@sb/store'
var sb = require('@sb/util')

export default {
	name: 'AgentsAvatar',

	props: ['mode', 'tooltipPos', 'agent_ids', 'border'],

	data () {
		return { ...store.bind(this, ['accountSetting']) }
	},

	render () {
		var agents = sb.map(this.agent_ids, id => store.agentM[id])
		if (this.agent_ids === undefined || sb.size(this.agent_ids) === 0) {
			var agids = sb.get(this.accountSetting, 'header.agent_ids', [])
			agids = sb.filter(agids, id => !!store.agentM[id])
			if (agids.length !== 0) {
				agents = sb.map(agids, id => store.agentM[id])
			} else {
				agents = sb.filter(store.agentM, agent => agent.type === 'agent')
			}
		}

		agents = sb.filter(agents, ag => !!ag)

		var tooltippos = this.tooltipPos || 'bottom'
		var mode = this.mode || 'primary'
		if (agents.length === 0) {
			// use account avatar
			return (
				<div class={`group-avatar group-avatar--${mode}`}>
					<div
						class="d-inline-block pos-relative"
						data-tooltip={sb.get(store.account, 'name')}
						data-tooltip-position={tooltippos}>
					<img class="avatar group-avatar--agent-left" src={sb.replaceFileUrl(sb.get(store.account, 'logo_url')) || require('../../assets/img/image_default.png')} />
					</div>
				</div>
			)
		}

		// 1 agent
		if (agents.length === 1) {
			var agent = agents[0]
			var groupClass = mode === 'primary' ? 'group-avatar--agent-middle' : 'group-avatar--agent-left'
			return (
				<div class={`group-avatar group-avatar--${mode}`}>
					<div
						class="d-inline-block pos-relative"
						data-tooltip={agent.fullname || store.account.name}
						data-tooltip-position={tooltippos}>
						<img
							class={`avatar ${groupClass}`}
				src={sb.replaceFileUrl(agent.avatar_url) || require('../../assets/img/default_avatar.png')}
						/>
					</div>
				</div>
			)
		}

		// 2 agent
		if (agents.length === 2) {
			let leftAgent = agents[0]
			let rightAgent = agents[1]
			return (
				<div class={`group-avatar group-avatar--${mode}`}>
					<div
						class="d-inline-block pos-relative"
						data-tooltip={leftAgent.fullname || store.account.name}
						data-tooltip-position={tooltippos}>
						<img
							class="avatar group-avatar--agent-left"
				src={sb.replaceFileUrl(leftAgent.avatar_url) || require('../../assets/img/default_avatar.png')}
						/>
					</div>
					<div
						class="d-inline-block pos-relative"
						data-tooltip={rightAgent.fullname || store.account.name}
						data-tooltip-position={tooltippos}>
						<img
							class="avatar group-avatar--agent-right"
				src={sb.replaceFileUrl(rightAgent.avatar_url) || require('../../assets/img/default_avatar.png')}
						/>
					</div>
				</div>
			)
		}

		// >=3 agent

		let leftAgent = agents[0]
		let middleAgent = agents[1]
		let rightAgent = agents[2]
		return (
			<div class={`group-avatar group-avatar--${mode}`}>
				<div
					class="d-inline-block pos-relative"
					data-tooltip={leftAgent.fullname || store.account.name}
					data-tooltip-position={tooltippos}>
					<img
						class="avatar group-avatar--agent-left"
			src={sb.replaceFileUrl(leftAgent.avatar_url) || require('../../assets/img/default_avatar.png')}
					/>
				</div>
				<div
					class="d-inline-block pos-relative"
					data-tooltip={middleAgent.fullname || store.account.name}
					data-tooltip-position={tooltippos}>
					<img
						class="avatar group-avatar--agent-middle"
			src={sb.replaceFileUrl(middleAgent.avatar_url) || require('../../assets/img/default_avatar.png')}
					/>
				</div>
				<div
					class="d-inline-block pos-relative"
					data-tooltip={rightAgent.fullname || store.account.name}
					data-tooltip-position={tooltippos}>
					<img
						class="avatar group-avatar--agent-right"
			src={sb.replaceFileUrl(rightAgent.avatar_url) || require('../../assets/img/default_avatar.png')}
					/>
				</div>
			</div>
		)
	},
}
